



































import { defineComponent, reactive, ref } from '@vue/composition-api';
import Axios from 'axios';
import Loading from '../Loading.vue';

const CommonUploadProductModal = defineComponent({
  components: {
    Loading,
  },
  setup(props, { emit }) {
    const priceType = ['PRODUCT', 'WEIGHT', 'VOLUME'];
    const priceTypeTH = ['ตามชิ้น', 'ตามน้ำหนัก', 'ตามปริมาตร'];
    const isLoading = ref(false);
    const modal = ref(null);
    const successModal = ref(null);
    const type = ref('PRODUCT');
    const form = reactive({
      file: null,
    });

    function updateFile($event: any) {
      if ($event.target.files.length > 0) {
        // eslint-disable-next-line
        form.file = $event.target.files[0];
      }
    }

    function open() {
      (modal.value as any).open();
    }
    function close() {
      (modal.value as any).close();
    }

    async function submit() {
      if (isLoading.value === false) {
        isLoading.value = true;
        const formData = new FormData();

        if (form.file) formData.append('file', form.file);
        formData.append('type', type.value);

        try {
          const res = await Axios.post(`${process.env.VUE_APP_BACKEND_HTTP}/api/upsert-product-area-price`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          console.log('[Uplaod file result⬆️]: ', res);

          isLoading.value = false;
          if (res.status === 200) {
            emit('success');
          } else {
            emit('failed');
          }
        } catch (error) {
          console.log('[Uplaod file error⬆️]: ', error);
          isLoading.value = false;
          emit('failed');
        }

        return null;
      }
      return null;
    }

    return {
      isLoading,
      form,
      modal,
      successModal,
      open,
      close,

      updateFile,
      submit,

      priceType,
      priceTypeTH,
      type,
    };
  },
});

export default CommonUploadProductModal;
